module.exports = __webpack_public_path__ + "static/img/56314651.5e657c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/56314651.jpg
// module id = 5mlk
// module chunks = 13